
import moment from 'moment'
import templateUrl from './event-scheduling-tsu-report-container.component.html'
import { EmployeeService } from '../../../../core/services/data-services/employee.service';
import { UtilityService } from '../../../../core/services/utility.service';

export const EventsSchedulingTsuReportContainerComponent = {
    controller: EventsSchedulingTsuReportContainerController,
    templateUrl
}

function EventsSchedulingTsuReportContainerController($q, apexApiUrl,
    employeeService: EmployeeService, utilityService: UtilityService,
    divisionService, icdCorporationService) {

    'ngInject'
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    vm.$onInit = activate;
    vm.loaded = false;
    vm.showFilters = true;
    vm.eventSchedulingTsuReport = [];
    vm.eventSchedulingEmployeeTsuReport = [];
    vm.headerDates = [];
    vm.onRefreshData = onRefreshData;
    vm.filters = {
        StartDate: moment().startOf("week").toDate(),
        EndDate: moment().endOf("week").toDate(),
        Type: 'Summary'
    };
    vm.onExport = onExport;


    vm.dropdownOptions = {
        optionLabel: { Id: null, OwnerClientName: vm.isSiteAdmin ? 'All' : 'Select company' },
        dataSource: new kendo.data.DataSource({
            data: vm.icdCorporations,
        }),
        headerTemplate: `
                    <div style="padding: 8px 12px; border-bottom: 1px solid \\#ddd; cursor: pointer;">
                        <label class="control control-checkbox" style="margin: 0;">
                            <input type="checkbox" id="allcorps" name="allcorps" />
                            <span class="control-indicator"></span>
                            <span>Show Active</span>
                        </label>
                    </div>
                `,
        open: () => {
            setTimeout(() => {
                const widget = $("#filterCompany").data("kendoDropDownList");
                const source = vm.icdCorporations;
                $("#allcorps").off("click").on("click", (e) => {
                    const isChecked = $(e.target).prop("checked");

                    const filtered = isChecked
                        ? source.filter(c => c.IcdCorporationStatus === 'Active')
                        : source;
                    widget.dataSource.data(filtered);
                    widget.refresh();
                    widget.popup.open(); // keep it open after refresh
                });
            }, 0);
        }
    }


    function activate() {
        const initialDataLoaded = loadInitialData();
        const identityLoaded = employeeService.retrieveIdentity()
            .then(identity => vm.isSiteAdmin = identity.IsSiteAdmin);
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError($q.all([initialDataLoaded, identityLoaded]), "Initial load failed"));
    }

    function onRefreshData() {
        clearReportData();
        if (vm.filters.Type === 'Summary') {
            vm.params = generateQueryParameter();
            vm.showSummaryReport = true;
        } else {
            vm.params = generateQueryParameter();
            vm.showEmployeeReport = true;
        }

    }

    function onExport() {
        const params = generateQueryParameter();
        const queryString = utilityService.queryStringify(params);

        let api;

        if (vm.filters.Type === 'Summary') {
            api = "schedule-events/report/tsu-report-summary.xlsx";
        } else {
            api = "schedule-events/report/employee-tsu-report.xlsx";
        }
        window.location.href = apexApiUrl + api + queryString
    }

    function loadInitialData() {

        const icdCorporationsLoaded = icdCorporationService.retrieveIcdCorporationsByModuleAdmin("Events Scheduling", {
            divisionID: divisionService.divisionIDs.Rogers
        })
            .then(function (icdCorporations) {
                vm.icdCorporations = icdCorporations;
                if (!vm.isSiteAdmin) {
                    vm.filters.IcdCorporation = icdCorporations[0]; // Not nullable.
                }
                vm.icdCorporations.forEach(formatIcdCorporation);
                vm.icdCorporations.sort(function (a, b) {
                    return a.OwnerClientName.toLowerCase() < b.OwnerClientName.toLowerCase() ? -1 : 1;
                });
                return icdCorporations;
            });

        return $q.all([icdCorporationsLoaded]);
    }

    function clearReportData() {
        vm.showEmployeeReport = false;
        vm.showSummaryReport = false;
    }

    function formatIcdCorporation(icdCorporation) {
        icdCorporation.OwnerClientName = icdCorporation.Owner + " - " + icdCorporation.ClientName;
    }

    function generateQueryParameter() {
        const params = {
            StartDate: moment(vm.filters.StartDate).format("YYYY-MM-DD"),
            EndDate: moment(vm.filters.EndDate).format("YYYY-MM-DD"),
            DivisionID: divisionService.divisionIDs.Rogers,
            IcdCorporationID: vm.filters.IcdCorporation ? vm.filters.IcdCorporation.Id : null
        }
        return params;
    }

}
